module.exports = __webpack_public_path__ + "img/stock2.5d7a287f.png";